import { useEffect, useState } from "react";

import CategoryTab from "../../../components/Admin/Common/CategoryTab";
import { MEDIA_TAB_CONTENT } from "../../../const/admin";
import { deleteMedia, getMediaCount, getMediaList } from "../../../api/admin";
import MediaContents from "../../../components/Admin/Media/MediaContents";
import useUpdateUrlWithQuery from "../../../utils/useUpdateUrlWithQuery";

const DEFAULT = "언론보도";
const DEFAULT_PAGE = 1;

export default function MediaManagement() {
  const [mediaTab, setMediaTab] = useState(MEDIA_TAB_CONTENT);
  const [mediaTotalCount, setMediaTotalCount] = useState(0);
  const [mediaList, setMediaList] = useState([]);
  const [currentPage, setCurrentPage] = useState(DEFAULT_PAGE);
  const [selectCategory, setSelectCategory] = useState(DEFAULT);
  const [searchValue, setSearchValue] = useState("");
  const updateUrlWithQuery = useUpdateUrlWithQuery();

  useEffect(() => {
    (async () => {
      const {
        data: { totalCount, mediaList },
      } = await getMediaList(currentPage, selectCategory, searchValue);
      const { data } = await getMediaCount();

      setMediaTab(data);
      setMediaTotalCount(totalCount);
      setMediaList(mediaList);
    })();
  }, [currentPage, selectCategory]);

  const handlePosition = (category: string) => {
    setSelectCategory(category);
  };

  const handleSearch = async (e: any) => {
    if (e.key === "Enter") {
      setCurrentPage(DEFAULT_PAGE);
      const {
        data: { totalCount, mediaList },
      } = await getMediaList(currentPage, selectCategory, searchValue);

      searchValue === ""
        ? updateUrlWithQuery([], true)
        : updateUrlWithQuery([
            { paramsKey: "search", paramsValue: searchValue },
          ]);

      setMediaTotalCount(totalCount);
      setMediaList(mediaList);
    }
  };

  const onClickDeleteButton = async (id: number) => {
    if (window.confirm("삭제하시겠습니까?")) {
      await deleteMedia(id);
      const {
        data: { totalCount, mediaList },
      } = await getMediaList(currentPage, selectCategory, searchValue);
      const { data } = await getMediaCount();

      setMediaTab(data);
      setMediaTotalCount(totalCount);
      setMediaList(mediaList);
    }
  };

  return (
    <section className="admin-common-container">
      <h2 className="admin-common-title">언론보도 관리</h2>
      <div className="admin-writing-wrapper">
        <CategoryTab
          list={mediaTab}
          onClick={handlePosition}
          selectCategory={selectCategory}
        />
        <MediaContents
          totalCount={mediaTotalCount}
          list={mediaList}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          setSearchValue={setSearchValue}
          handleSearch={handleSearch}
          onClickDeleteButton={onClickDeleteButton}
        />
      </div>
    </section>
  );
}
